import { Injectable } from '@angular/core';
import { FspDocumentsRequestGridDto } from './fsp-documents-grid-data-model';
import { GridDataService } from '../../gk-kendo';

@Injectable({
  providedIn: 'any',
})
export class FspDocumentsGridDataService extends GridDataService<FspDocumentsRequestGridDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
